"use strict";

exports.__esModule = true;
exports.MetricTableTargetsController = MetricTableTargetsController;
var _uniq2 = _interopRequireDefault(require("ramda/src/uniq"));
var _react = _interopRequireDefault(require("react"));
var _RestAPI = require("../../API/RestAPI");
var _pivotByTarget = require("./pivotByTarget");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function MetricTableTargetsController(_ref) {
  var children = _ref.children,
    filters = _ref.filters,
    _ref$tableData = _ref.tableData,
    tableData = _ref$tableData === void 0 ? [] : _ref$tableData,
    timeAggregationName = _ref.timeAggregationName,
    shiftAggregationName = _ref.shiftAggregationName,
    kindAggregationName = _ref.kindAggregationName,
    time = _ref.time;
  var options = _react["default"].useMemo(function () {
    return {
      method: "POST",
      body: filters && {
        scope: {
          device_id: (0, _uniq2["default"])(tableData.map(function (row) {
            return row.device;
          })),
          kind_id: (0, _uniq2["default"])(tableData.map(function (row) {
            return row.kind;
          })),
          shift: (0, _uniq2["default"])(tableData.map(function (row) {
            return row.shift;
          }))
        },
        startWorkday: filters.WorkdayRangeSelector.gte.slice(0, 10),
        endWorkday: filters.WorkdayRangeSelector.lt.slice(0, 10)
      }
    } || {};
  }, [filters, tableData]);
  var formatDataProps = {
    shouldFormat: true,
    formatFn: (0, _pivotByTarget.pivotByTarget)({
      tableData: tableData,
      timeAggregationName: timeAggregationName,
      shiftAggregationName: shiftAggregationName,
      kindAggregationName: kindAggregationName,
      time: time
    })
  };
  var _useRestApi = (0, _RestAPI.useRestApi)({
      url: "/api/v3/target/search",
      options: options,
      formatDataProps: formatDataProps
    }),
    loading = _useRestApi.loading,
    data = _useRestApi.data;
  return children({
    data: data,
    loading: loading
  });
}